export default __webpack_public_path__ + "static/media/x-icon.a702f053.png";